import { useEffect, useState } from 'react'
import '../../../assets/styles/customFilter.css'
import { RangeSlider } from './RangeSlider'

const CustomRangeFilter = (props) => {
  const { colDef, setApiParams } = props;
  const { id } = colDef
  const [selectedFilter, setSelectedFilter] = useState("")
  const [minVal, setMinVal] = useState(null)
  const [maxVal, setMaxVal] = useState(null)
  const renderedValues = {
    min: colDef?.fieldData?.minVal ?? colDef?.fieldData?.min_value,
    max: colDef?.fieldData?.maxVal ?? colDef?.fieldData?.max_value
  }

  useEffect(() => {
    setApiParams(oldParams => {
      try {
        if (minVal == colDef?.fieldData?.min_value && maxVal == colDef?.fieldData?.max_value) {
          return {
            ...oldParams,
            filterCols: [...oldParams.filterCols.filter(filter => filter.colId !== id)]
          }

        } else if ((!['', 'between'].includes(selectedFilter) && minVal) ||
          (selectedFilter === 'between' && minVal && maxVal && parseFloat(minVal) < parseFloat(maxVal))) {
          const newFilterColDef = {
            colId: id,
            filterType: selectedFilter,
            dataType: 'number',
            minVal,
            maxVal: selectedFilter === 'between' ? maxVal : null
          }
          return {
            ...oldParams,
            filterCols: oldParams.filterCols.find(filter => filter.colId === id) ?
              [...oldParams.filterCols.filter(filter => filter.colId !== id), newFilterColDef] :
              [...oldParams.filterCols, newFilterColDef]
          }
        } else {

          return {
            ...oldParams,
            filterCols: [...oldParams.filterCols.filter(filter => filter.colId !== id)]
          }
        }
      } catch (error) {
        console.log(error)
        return { ...oldParams }
      }
    })
  }, [minVal, maxVal])

  const handleValuesChange = (newValues) => {
    setMinVal(newValues[0]?.toString())
    setMaxVal(newValues[1]?.toString())
    setSelectedFilter("between")
  };

  const resetFilters = () => {
    setMinVal(renderedValues?.min)
    setMaxVal(renderedValues?.max)
    setSelectedFilter("between")
  };

  return (
    <div className="customFilter">
      <div>
        <RangeSlider
          initialMin={renderedValues?.min ?? 0}
          initialMax={renderedValues?.max ?? 1000}
          minLimit={renderedValues?.min ?? 0}
          maxLimit={renderedValues?.max ?? 1000}
          onValuesChange={handleValuesChange}
          resetFilters={resetFilters}
        />
      </div>

    </div>
  )
}

export default CustomRangeFilter
